import { alternaleaf, BrandThemeProvider } from '@montugroup/themes';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { Notices } from '@/components/layout/Notices';
import { Logger } from '@/utils/logger';
import AuthService from '@montugroup/circuit-shared/services/authentication.service';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import Error404 from '@/pages/error/404';
import { ACTOR_TYPE, useSessionHeartbeat } from '@montugroup/circuit-shared';
import { CircularProgressWrapper } from '@montugroup/circuit-shared/components/common/CircularProgressWrapper';
import useUser from '@montugroup/circuit-shared/hooks/user/useUser';
import { PageLayout } from '../layout/PageLayout';

const logger = new Logger('requireAuth');

function RequireAuth() {
  const shouldUseSessionHeartbeat = useFeatureFlag('auth_enable_session_heartbeat');
  const { data: user, isLoading: userIsLoading } = useUser();
  useSessionHeartbeat({ enabled: Boolean(user && shouldUseSessionHeartbeat) });
  const location = useLocation();

  useEffect(() => {
    if (!user && !userIsLoading) {
      logger.info('useEffect logout');
      AuthService.logout({ reason: 'expired' });
    }
  }, [location.pathname, user, userIsLoading]);

  if (!user) {
    logger.info('loadingSpinnerHit', {
      '!user': !user,
      userIsLoading,
    });

    return <CircularProgressWrapper />;
  }

  logger.info('notLoading');

  // Check if user is patient actorType - required for all patient-portal routes
  if (user.actorType !== ACTOR_TYPE.patient) {
    logger.info('User is not patient actorType', {
      pathname: location.pathname,
      'user.id': user.id,
      'user.actorType': user.actorType,
    });

    return <Error404 />;
  }

  return (
    <>
      <Notices />
      <BrandThemeProvider theme={alternaleaf}>
        <PageLayout>
          <Outlet />
        </PageLayout>
      </BrandThemeProvider>
    </>
  );
}

export default RequireAuth;
